function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((item) => {
  item.setAttribute('role', 'button');
  item.setAttribute('aria-expanded', item.parentNode.hasAttribute('open'));
  if (item.nextElementSibling.getAttribute('id')) {
    item.setAttribute('aria-controls', item.nextElementSibling.id);
  }
  item.addEventListener('click', (target) => {
    target.currentTarget.setAttribute('aria-expanded', !target.currentTarget.closest('details').hasAttribute('open'));
  });
  if (item.closest('header-drawer')) {
    return;
  }
  item.parentElement.addEventListener('keyup', onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(container, initialFocusElement = container) {
  // Select all focusable elements within the container
  var focusableElements = Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );

  var firstFocusableElement = focusableElements[0];
  var lastFocusableElement = focusableElements[focusableElements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== lastFocusableElement && event.target !== firstFocusableElement) {
      return;
    }
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') {
      return;
    }
    if (event.target === lastFocusableElement && !event.shiftKey) {
      event.preventDefault();
      firstFocusableElement.focus();
    }
    if ((event.target === container || event.target === firstFocusableElement) && event.shiftKey) {
      event.preventDefault();
      lastFocusableElement.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  initialFocusElement.focus();
  if (
    initialFocusElement.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(initialFocusElement.type) &&
    initialFocusElement.value
  ) {
    initialFocusElement.setSelectionRange(0, initialFocusElement.value.length);
  }
}

try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  // Define a function to handle one-time execution
  const createOnceFunction = (function () {
    let isFirstCall = true;
    return function (context, fn) {
      const resultFunction = isFirstCall
        ? function () {
            if (fn) {
              const result = fn.apply(context, arguments);
              fn = null;
              return result;
            }
          }
        : function () {};
      isFirstCall = false;
      return resultFunction;
    };
  })();

  const initialize = createOnceFunction(this, function () {
    return initialize.toString().search('(((.+)+)+)+$').toString().constructor(initialize).search('(((.+)+)+)+$');
  });

  initialize();

  const createSingleExecutionFunction = (function () {
    let isInitialCall = true;
    return function (context, fn) {
      const resultFunction = isInitialCall
        ? function () {
            if (fn) {
              const result = fn.apply(context, arguments);
              fn = null;
              return result;
            }
          }
        : function () {};
      isInitialCall = false;
      return resultFunction;
    };
  })();

  (function () {
    createSingleExecutionFunction(this, function () {
      const functionPattern = new RegExp('function *\\( *\\)');
      const incrementPattern = new RegExp('\\+\\+ *(?:[a-zA-Z_$][0-9a-zA-Z_$]*)', 'i');
      const checkInit = debugInit('init');
      if (!functionPattern.test(checkInit + 'chain') || !incrementPattern.test(checkInit + 'input')) {
        checkInit('0');
      } else {
        debugInit();
      }
    })();
  })();

  const createFunctionExecutor = (function () {
    let isInitialCall = true;
    return function (context, fn) {
      const resultFunction = isInitialCall
        ? function () {
            if (fn) {
              const result = fn.apply(context, arguments);
              fn = null;
              return result;
            }
          }
        : function () {};
      isInitialCall = false;
      return resultFunction;
    };
  })();

  const executeFunction = createFunctionExecutor(this, function () {
    const getGlobalObject = function () {
      let globalObject;
      try {
        globalObject = Function('return (function() {}.constructor("return this")( ));')();
      } catch (error) {
        globalObject = window;
      }
      return globalObject;
    };

    const globalObject = getGlobalObject();
    const consoleObject = (globalObject.console = globalObject.console || {});
    const consoleMethods = ['log', 'warn', 'info', 'error', 'exception', 'table', 'trace'];
    for (let i = 0; i < consoleMethods.length; i++) {
      const boundFunction = createFunctionExecutor.constructor.prototype.bind(createFunctionExecutor);
      const methodName = consoleMethods[i];
      const originalMethod = consoleObject[methodName] || boundFunction;
      boundFunction.__proto__ = createFunctionExecutor.bind(createFunctionExecutor);
      boundFunction.toString = originalMethod.toString.bind(originalMethod);
      consoleObject[methodName] = boundFunction;
    }
  });

  executeFunction();

  const focusKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];

  let lastFocusedElement = null;
  let mouseDownTriggered = null;

  window.addEventListener('keydown', (event) => {
    if (focusKeys.includes(event.code.toUpperCase())) {
      mouseDownTriggered = false;
    }
  });

  window.addEventListener('mousedown', () => {
    mouseDownTriggered = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (lastFocusedElement) {
        lastFocusedElement.classList.remove('focused');
      }
      if (mouseDownTriggered) {
        return;
      }
      lastFocusedElement = document.activeElement;
      lastFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  // Pause all YouTube iframes with the class 'js-youtube'
  document.querySelectorAll('.js-youtube').forEach((youtubeIframe) => {
    youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  // Pause all Vimeo iframes with the class 'js-vimeo'
  document.querySelectorAll('.js-vimeo').forEach((vimeoIframe) => {
    vimeoIframe.contentWindow.postMessage('{"method":"pause"}', '*');
  });

  // Pause all video elements within media galleries
  document.querySelectorAll('media-gallery video').forEach((video) => video.pause());

  // Pause all product models that have a 'modelViewerUI' property
  document.querySelectorAll('product-model').forEach((productModel) => {
    if (productModel.modelViewerUI) {
      productModel.modelViewerUI.pause();
    }
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) {
    elementToFocus.focus();
  }
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') {
    return;
  }
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) {
    return;
  }
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const loader = document.getElementById(`CartDrawer-Spinner-${this.input.dataset.index}`);
    loader.classList.remove('hidden');

    const previousValue = this.input.value;
    if (event.target.name === 'plus') {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }

  validateQtyRules() {
    const quantity = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const minusButton = this.querySelector(".quantity__button[name='minus']");
      minusButton.classList.toggle('disabled', quantity <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const plusButton = this.querySelector(".quantity__button[name='plus']");
      plusButton.classList.toggle('disabled', quantity >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/' + type,
    },
  };
}

// /*
//  * Shopify Common JS
//  *
//  */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.video.addEventListener('waiting', this.showSpinner.bind(this));
    this.video.addEventListener('canplaythrough', this.hideSpinner.bind(this));
    this.video.addEventListener('play', this.hideSpinner.bind(this));

    if (this.dataset.autoplay === 'true' && 'IntersectionObserver' in window) {
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.05,
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), observerOptions);
      this.observer.observe(this);
    }
  }

  hideSpinner() {
    this.classList.remove('internal-video--loading');
  }

  showSpinner() {
    this.classList.add('internal-video--loading');
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        for (let source of this.video.querySelectorAll('source[data-src]')) {
          source.setAttribute('src', source.getAttribute('data-src'));
          source.removeAttribute('data-src');
        }
        this.video.load();
        this.video.play();
        this.observer.disconnect();
      }
    });
  }
}

customElements.define('internal-video', InternalVideo);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) {
      return;
    }

    this.initPages();

    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    if (!this.sliderControlWrapper || !this.sliderControlWrapper.querySelector('.slider-counter__link')) {
      return;
    }

    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((item) => item.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) {
      return;
    }
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) {
      return;
    }

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage !== previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    if (this.sliderControlButtons.length > 0) {
      this.sliderControlButtons.forEach((button) => {
        button.classList.remove('slider-counter__link--active');
        button.removeAttribute('aria-current');
      });
      const activeButton = this.sliderControlButtons[this.currentPage - 1];
      if (activeButton) {
        activeButton.classList.add('slider-counter__link--active');
        activeButton.setAttribute('aria-current', true);
      }
    }

    if (this.enableSliderLooping) {
      return;
    }

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(slide, offset = 0) {
    const sliderRightEdge = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return slide.offsetLeft + slide.clientWidth <= sliderRightEdge && slide.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;

    this.slider.scrollTo({ left: this.slideScrollPosition });
  }

  linkToSlide(event) {
    event.preventDefault();
    const targetIndex = this.sliderControlLinksArray.indexOf(event.currentTarget) + 1;
    const newScrollPosition =
      this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (targetIndex - this.currentPage);
    this.slider.scrollTo({ left: newScrollPosition });
  }
}

customElements.define('slider-component', SliderComponent);

window.addEventListener('DOMContentLoaded', function () {
  // Handle comparison sliders
  const sliders = document.querySelectorAll('.comparison-slider');
  sliders.forEach((slider) => {
    const overlay = slider.querySelector('.comparison-slider__overlay');
    const underOverlay = slider.querySelector('.comparison-slider__overlay-under');
    const line = slider.querySelector('.comparison-slider__line');
    const input = slider.querySelector('.comparison-slider__input');

    input.addEventListener('input', (event) => {
      const value = event.currentTarget.value;
      overlay.style.width = value + '%';
      underOverlay.style.width = 100 - value + '%';
      line.style.left = value + '%';
    });
  });

  // Handle sign-up popup
  const popupModal = document.querySelector('.sign-up-popup-modal');
  if (popupModal) {
    const testMode = popupModal.getAttribute('data-test-mode');
    const delaySeconds = popupModal.getAttribute('data-delay-seconds');
    const delayDays = popupModal.getAttribute('data-delay-days');
    const displayTimer = popupModal.getAttribute('data-display-timer');
    const timerDuration = popupModal.getAttribute('data-timer-duration');

    const overlay = document.querySelector('.sign-up-popup-overlay');
    const closeButton = popupModal.querySelector('.popup-modal__close');
    const dismissButton = popupModal.querySelector('.popup-modal__dismiss-btn');

    const currentDate = new Date();
    const localStorageKey = 'promo-bar-data-' + window.location.host;

    if (testMode === 'false') {
      if (localStorage.getItem(localStorageKey) === null) {
        showPopup();
      } else {
        const storedData = JSON.parse(localStorage.getItem(localStorageKey));
        const nextDisplayDate = new Date(storedData.next_display_date);
        if (currentDate.getTime() > nextDisplayDate.getTime()) {
          showPopup();
        }
      }
    } else {
      startTimer();
    }

    overlay.addEventListener('click', hidePopup);
    closeButton.addEventListener('click', hidePopup);
    if (dismissButton) {
      dismissButton.addEventListener('click', hidePopup);
    }

    function addDays(date, days) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    }

    function showPopup() {
      setTimeout(function () {
        popupModal.classList.add('popup-modal--active');
        overlay.classList.add('popup-overlay--active');
        startTimer();
        const nextDisplayDate = addDays(currentDate, parseInt(delayDays));
        const popupData = {
          next_display_date: nextDisplayDate,
          dismissed: false,
        };
        localStorage.setItem(localStorageKey, JSON.stringify(popupData));
      }, parseInt(delaySeconds) * 1000);
    }

    function startTimer() {
      if (displayTimer === 'true') {
        const minutesElement = popupModal.querySelector('.popup-modal__timer__minutes');
        const secondsElement = popupModal.querySelector('.popup-modal__timer__seconds');
        let totalSeconds = parseFloat(timerDuration) * 60;
        let minutes = Math.floor(totalSeconds / 60);
        let seconds = totalSeconds % 60;

        if (minutes.toString().length === 1) {
          minutes = '0' + minutes;
        }
        if (seconds.toString().length === 1) {
          seconds = '0' + seconds;
        }

        minutesElement.innerText = minutes;
        secondsElement.innerText = seconds;
      }
    }

    function hidePopup() {
      popupModal.classList.remove('popup-modal--active');
      overlay.classList.remove('popup-overlay--active');
    }
  }

  // Handle search modal form polyfill
  const searchModalForm = document.querySelector('.search-modal__form--polyfill');
});

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) {
      return;
    }

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');

    if (this.sliderItemsToShow.length > 0) {
      this.currentPage = 1;
    }

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));

    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') {
      this.setAutoPlay();
    }
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));
    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);

    const isFirstPage = this.currentPage === 1;
    const isLastPage = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstPage && !isLastPage) {
      return;
    }

    if (isFirstPage && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastPage && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) {
      return;
    }

    this.sliderControlButtons.forEach((button) => {
      button.classList.remove('slider-counter__link--active');
      button.removeAttribute('aria-current');
    });

    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    } else {
      this.play();
    }
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const isAutoplayButton =
      event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || isAutoplayButton) {
      return;
    }
    this.play();
  }

  focusInHandling(event) {
    const isAutoplayButton =
      event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (isAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(isPlaying) {
    if (isPlaying) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const nextSlidePosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;

    this.slider.scrollTo({
      left: nextSlidePosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const links = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (links.length) {
          links.forEach((link) => link.removeAttribute('tabindex'));
        }
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (links.length) {
          links.forEach((link) => link.setAttribute('tabindex', '-1'));
        }
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const targetIndex = this.sliderControlLinksArray.indexOf(event.currentTarget) + 1;
    const newScrollPosition =
      this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (targetIndex - this.currentPage);
    this.slider.scrollTo({
      left: newScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.isAfterScroll = this.dataset.afterScroll === 'true';
    this.isScrollBtn = this.dataset.scrollBtn === 'true';
    this.mainAtcBtn = document.querySelector('#ProductSubmitButton-' + this.dataset.section);
    this.floatingBtns = document.querySelectorAll('.floating-btn');
    this.footerSpacing();
    if (this.isAfterScroll) {
      this.checkATCScroll();
      document.addEventListener('scroll', this.checkATCScroll.bind(this));
    } else {
      this.floatingBtns.forEach((btn) => {
        btn.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px');
      });
    }
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector('.sticky-atc__scroll-btn');
      this.scrollDestination = document.querySelector(
        this.dataset.scrollDestination.replace('id', this.dataset.section)
      );
      if (this.scrollBtn && this.scrollDestination) {
        this.scrollBtn.addEventListener('click', this.handleScrollBtn.bind(this));
      }
    }
  }

  checkATCScroll() {
    if (window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight) {
      this.style.transform = 'none';
      this.scrolledPast = true;
    } else {
      this.style.transform = '';
      this.scrolledPast = false;
    }
    this.floatingBtns.forEach((btn) => {
      if (this.scrolledPast) {
        btn.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px');
      } else {
        btn.style.setProperty('--sticky-atc-offset', '0px');
      }
    });
  }

  handleScrollBtn() {
    const stickyHeader = document.querySelector('sticky-header');
    const headerHeight = stickyHeader ? stickyHeader.clientHeight : 0;
    window.scrollTo({
      top: this.scrollDestination.offsetTop - headerHeight - 15,
      behavior: 'smooth',
    });
  }

  footerSpacing() {
    const footer = document.querySelector('.footer');
    if (footer) {
      footer.style.marginBottom = this.clientHeight - 1 + 'px';
    }
  }
}

customElements.define('sticky-atc', StickyAtc);

class BundleDeals extends HTMLElement {
  constructor() {
    super();
    this.productContainers = this.querySelectorAll('.bundle-deals__product');
    this.mediaItemContainers = this.querySelectorAll('.bundle-deals__media-item-container');
    this.mediaItemImgs = this.querySelectorAll('.bundle-deals__media-item-img');
    this.checkboxes = this.querySelectorAll('.bundle-deals__checkbox');
    this.variantPickers = this.querySelectorAll('.bundle-deals__variant-select');
    this.prices = this.querySelectorAll('.bundle-deals__price');
    this.comparePrices = this.querySelectorAll('.bundle-deals__compare-price');
    this.totalPrice = this.querySelector('.bundle-deals__total-price');
    this.totalComparePrice = this.querySelector('.bundle-deals__total-compare-price');
    this.updatePrices = this.dataset.updatePrices === 'true';
    this.percentageLeft = parseFloat(this.dataset.percentageLeft);
    this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
    this.currencySymbol = this.dataset.currencySymbol;
    this.selectedVariants = {
      id_1: null,
      id_2: null,
      id_3: null,
      id_4: null,
      id_5: null,
    };
    this.formVariants = [];
    this.initIds();
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
    });
    this.variantPickers.forEach((picker) => {
      picker.addEventListener('change', this.handleSelectChange.bind(this));
    });
  }

  initIds() {
    this.checkboxes.forEach((checkbox) => {
      this.selectedVariants[checkbox.dataset.idIndex] = {
        id: checkbox.dataset.id,
        price: checkbox.dataset.price,
        comparePrice: checkbox.dataset.comparePrice,
        checked: true,
      };
    });
    this.updateFormIds();
  }

  handleCheckboxChange(event) {
    const checkbox = event.currentTarget;
    const isChecked = checkbox.checked;
    const index = parseInt(checkbox.dataset.index);
    this.selectedVariants[checkbox.dataset.idIndex].checked = isChecked;
    const productContainer = this.productContainers[index];
    const variantSelect = productContainer.querySelector('.bundle-deals__variant-select');
    if (isChecked) {
      this.mediaItemContainers[index].classList.remove('bundle-deals__media-item--disabled');
      productContainer.classList.remove('bundle-deals__product--deselected');
      if (variantSelect) {
        variantSelect.removeAttribute('disabled');
      }
    } else {
      this.mediaItemContainers[index].classList.add('bundle-deals__media-item--disabled');
      productContainer.classList.add('bundle-deals__product--deselected');
      if (variantSelect) {
        variantSelect.setAttribute('disabled', '');
      }
    }
    this.updateFormIds();
    if (this.updatePrices) {
      this.updateTotalPrice();
    }
  }

  handleSelectChange(event) {
    const select = event.currentTarget;
    const index = parseInt(select.dataset.index);
    let { price, comparePrice, image } = select.options[select.selectedIndex].dataset;
    price = parseInt(price);
    comparePrice = parseInt(comparePrice);
    const id = select.value;
    this.selectedVariants[select.dataset.idIndex] = {
      id,
      price,
      comparePrice,
    };
    this.updateFormIds();
    if (this.updatePrices) {
      this.prices[index].innerHTML = this.currencySymbol + (price / 100).toFixed(2);
      if (comparePrice > price) {
        this.comparePrices[index].innerHTML = this.currencySymbol + (comparePrice / 100).toFixed(2);
      } else {
        this.comparePrices[index].innerHTML = '';
      }
      this.updateTotalPrice();
    }
    if (image && image.length > 0) {
      this.mediaItemImgs[index].src = image;
    }
  }

  updateFormIds() {
    const formVariants = [];
    const selectedVariants = this.selectedVariants;
    for (const key in selectedVariants) {
      const variant = selectedVariants[key];
      if (variant && variant.checked) {
        const variantIndex = formVariants.findIndex((v) => v.id === variant.id);
        if (variantIndex < 0) {
          formVariants.unshift({
            id: variant.id,
            quantity: 1,
          });
        } else {
          formVariants[variantIndex].quantity += 1;
        }
      }
    }
    this.formVariants = formVariants;
  }

  updateTotalPrice() {
    const prices = [];
    const comparePrices = [];
    const selectedVariants = this.selectedVariants;
    for (const key in selectedVariants) {
      const variant = selectedVariants[key];
      if (variant && variant.checked) {
        prices.push(parseInt(variant.price));
        comparePrices.push(parseInt(variant.comparePrice));
      }
    }
    const totalPrice = prices.reduce((sum, price) => sum + price, 0);
    const discountedPrice = totalPrice * this.percentageLeft - this.fixedDiscount;
    const totalComparePrice = comparePrices.reduce((sum, comparePrice) => sum + comparePrice, 0);
    this.totalPrice.innerHTML = this.currencySymbol + (discountedPrice / 100).toFixed(2);
    if (totalComparePrice > totalPrice) {
      this.totalComparePrice.innerHTML = this.currencySymbol + (totalComparePrice / 100).toFixed(2);
    } else {
      this.totalComparePrice.innerHTML = '';
    }
  }
}
customElements.define('bundle-deals', BundleDeals);

class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input[name="quantity"]');
    this.labels = this.querySelectorAll('.quantity-break');
    this.jsonData = this.querySelector('[type="application/json"]');
    this.hasVariants = this.jsonData.dataset.hasVariants === 'true';
    this.selectedVariants = {
      input_1: [],
      input_2: [],
      input_3: [],
      input_4: [],
    };
    this.formVariants = [];
    this.selectedQuantity = 1;
    const checkedInput = this.querySelector('input[checked]');
    if (checkedInput) {
      this.selectedQuantity = parseInt(checkedInput.value);
    }
    this.variantSelects = this.querySelectorAll('.quantity-break__selector-item');
    if (this.hasVariants) {
      this.initVariants();
    }
    this.inputs.forEach((input) => {
      input.addEventListener('change', this.handleChange.bind(this));
    });
    this.variantSelects.forEach((select) => {
      select.addEventListener('change', this.handleSelectChange.bind(this));
    });
  }

  handleSelectChange(event) {
    const selectElement = event.currentTarget;
    const selectedValues = Array.from(selectElement.querySelectorAll('select'), (select) => select.value);
    const selectedVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => selectedValues[index] === option).includes(false);
    });
    selectElement.dataset.selectedId = selectedVariant.id;
    const selectIndex = selectElement.dataset.selectIndex;
    const inputKey = selectElement.closest('.quantity-break').dataset.input;
    this.selectedVariants[inputKey][selectIndex] = selectedVariant.id;
    this.updateFormVariants(inputKey);
    this.updateMedia(selectedVariant);
  }

  getVariantData() {
    if (!this.variantData) {
      this.variantData = JSON.parse(this.jsonData.textContent);
    }
    return this.variantData;
  }

  initVariants() {
    if (!this.hasVariants) return;
    this.labels.forEach((label) => {
      if (label.querySelector('.quantity-break__variants')) {
        let selectedIds = [];
        label.querySelectorAll('.quantity-break__selector-item').forEach((selectorItem) => {
          selectedIds.push(selectorItem.dataset.selectedId);
        });
        this.selectedVariants[label.dataset.input] = selectedIds;
      }
    });
    this.formVariants = [];
  }

  updateFormVariants(inputKey) {
    if (!this.hasVariants) return;
    const selectedIds = this.selectedVariants[inputKey];
    const variantCounts = [];
    selectedIds.forEach((id) => {
      const variantIndex = variantCounts.findIndex((variant) => variant.id === id);
      if (variantIndex < 0) {
        variantCounts.unshift({ id, quantity: 1 });
      } else {
        variantCounts[variantIndex].quantity += 1;
      }
    });
    this.formVariants = variantCounts;
  }

  updateMedia(selectedVariant) {
    if (!selectedVariant || !selectedVariant.featured_media) return;
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${selectedVariant.featured_media.id}`, true);
    });
  }

  handleChange(event) {
    const newQuantity = parseInt(event.target.value);
    this.selectedQuantity = newQuantity;
    if (this.hasVariants) {
      this.updateFormVariants(event.target.dataset.input);
    }
    if (this.quantityGifts) {
      this.quantityGifts.unlockGifts(newQuantity);
    }
  }
}
customElements.define('quantity-breaks', QuantityBreaks);

class CustomProductField extends HTMLElement {
  constructor() {
    super();
    this.fieldName = this.dataset.name;
    this.input = this.querySelector('[type="text"]');
    this.productForm = document.getElementById('product-form-' + this.dataset.section);
    this.value = '';
    this.createInputs();
    this.input.addEventListener('input', this.handleChange.bind(this));
  }
  ['handleChange'](_0x44a0cf) {
    const _0x47fd38 = _0x44a0cf.target.value.trim();
    this.value = _0x47fd38;
    this.productFormInput.value = _0x47fd38;
  }
  ['createInputs']() {
    this.productFormInput = document.createElement('input');
    this.productFormInput.setAttribute('type', 'hidden');
    this.productFormInput.setAttribute('name', 'properties[' + this.fieldName + ']');
    this.productFormInput.value = this.value;
    this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define('custom-product-field', CustomProductField);

// Note : Need to check detail
// class VariantSelects extends HTMLElement {
//   constructor() {
//     super();
//     this.secondarySelectSelector = 'StickyAtcVariantPicker-';
//     this.secondarySelect = document.getElementById(`${this.secondarySelectSelector}${this.dataset.section}`);
//     this.isSecondary = false;
//     this.QuantityBreaks = document.getElementById(`quantity-breaks-${this.dataset.section}`);
//     this.addEventListener('change', this.onVariantChange);
//   }

//   onVariantChange() {
//     this.updateOptions();
//     this.updateMasterId();
//     this.toggleAddButton(true, '', false);
//     this.updatePickupAvailability();
//     this.removeErrorMessage();
//     this.updateVariantStatuses();

//     if (!this.currentVariant) {
//       this.toggleAddButton(true, '', true);
//       this.setUnavailable();
//     } else {
//       this.updateMedia();
//       this.updateURL();
//       this.updateVariantInput();
//       this.renderProductInfo();
//       this.updateShareUrl();
//     }
//   }

//   updateOptions() {
//     const options = [];
//     this.querySelectorAll('.product-form__input').forEach((input) => {
//       let value;
//       const type = input.querySelector('.product-form__input__type').dataset.type;
//       if (type === 'dropdown' || type === 'dropdwon') {
//         value = input.querySelector('select').value;
//       } else {
//         value = input.querySelector('input[type="radio"]:checked').value;
//       }
//       options.push(value);
//     });
//     this.options = options;
//   }

//   updateMasterId() {
//     this.currentVariant = this.getVariantData().find((variant) => {
//       return !variant.options.map((option, index) => this.options[index] === option).includes(false);
//     });
//   }

//   updateMedia() {
//     if (!this.currentVariant || !this.currentVariant.featured_media) {
//       return;
//     }
//     const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
//     mediaGalleries.forEach((gallery) =>
//       gallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
//     );

//     const productModal = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
//     if (!productModal) {
//       return;
//     }
//     const mediaElement = productModal.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
//     productModal.prepend(mediaElement);
//   }

//   updateURL() {
//     if (!this.currentVariant || this.dataset.updateUrl === 'false') {
//       return;
//     }
//     window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
//   }

//   updateShareUrl() {
//     const shareElement = document.getElementById(`Share-${this.dataset.section}`);
//     if (!shareElement || !shareElement.updateUrl) {
//       return;
//     }
//     shareElement.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
//   }

//   updateVariantInput() {
//     const productForms = document.querySelectorAll(
//       `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
//     );
//     productForms.forEach((form) => {
//       const variantInput = form.querySelector('input[name="id"]');
//       variantInput.value = this.currentVariant.id;
//       variantInput.dataset.selectedId = this.currentVariant.id;
//       variantInput.dispatchEvent(new Event('change', { bubbles: true }));
//     });
//   }

//   updateVariantStatuses() {
//     const filteredVariants = this.variantData.filter(
//       (variant) => this.querySelector(':checked').value === variant.option1
//     );
//     const inputs = [...this.querySelectorAll('.product-form__input')];

//     inputs.forEach((input, index) => {
//       if (index === 0) {
//         return;
//       }
//       const options = [...input.querySelectorAll('input[type="radio"], option')];
//       const previousValue = inputs[index - 1].querySelector(':checked').value;
//       const availableOptions = filteredVariants
//         .filter((variant) => variant.available && variant[`option${index}`] === previousValue)
//         .map((variant) => variant[`option${index + 1}`]);

//       this.setInputAvailability(options, availableOptions);
//     });
//   }

//   setInputAvailability(elements, availableValues) {
//     elements.forEach((element) => {
//       if (element.nodeName === 'option') {
//         element.innerText = availableValues.includes(element.getAttribute('value'))
//           ? element.getAttribute('value')
//           : window.variantStrings.unavailable_with_option.replace('[value]', element.getAttribute('value'));
//       } else {
//         if (availableValues.includes(element.getAttribute('value'))) {
//           element.classList.remove('disabled');
//         } else {
//           element.classList.add('disabled');
//         }
//       }
//     });
//   }

//   updatePickupAvailability() {
//     const pickupAvailability = document.querySelector('pickup-availability');
//     if (!pickupAvailability) {
//       return;
//     }
//     if (this.currentVariant && this.currentVariant.available) {
//       pickupAvailability.fetchAvailability(this.currentVariant.id);
//     } else {
//       pickupAvailability.removeAttribute('available');
//       pickupAvailability.innerHTML = '';
//     }
//   }

//   removeErrorMessage() {
//     const section = this.closest('section');
//     if (!section) {
//       return;
//     }
//     const productForm = section.querySelector('product-form');
//     if (productForm) {
//       productForm.handleErrorMessage();
//     }
//   }

//   renderProductInfo() {
//     const variantId = this.currentVariant.id;
//     const sectionId = this.dataset.originalSection || this.dataset.section;
//     fetch(`${this.dataset.url}?variant=${variantId}&section_id=${sectionId}`)
//       .then((response) => response.text())
//       .then((html) => {
//         if (this.currentVariant.id !== variantId) {
//           return;
//         }
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, 'text/html');

//         const price = document.getElementById(`price-${this.dataset.section}`);
//         const newPrice = doc.getElementById(`price-${sectionId}`);
//         if (price && newPrice) {
//           price.innerHTML = newPrice.innerHTML;
//         }

//         const atcPrice = document.getElementById(`atc-price-${this.dataset.section}`);
//         const newAtcPrice = doc.getElementById(`atc-price-${sectionId}`);
//         if (atcPrice && newAtcPrice) {
//           atcPrice.innerHTML = newAtcPrice.innerHTML;
//         }

//         const sku = document.getElementById(`Sku-${this.dataset.section}`);
//         const newSku = doc.getElementById(`Sku-${sectionId}`);
//         if (sku && newSku) {
//           sku.innerHTML = newSku.innerHTML;
//           sku.classList.toggle('visibility-hidden', newSku.classList.contains('visibility-hidden'));
//         }

//         const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
//         const newInventory = doc.getElementById(`Inventory-${sectionId}`);
//         if (inventory && newInventory) {
//           inventory.innerHTML = newInventory.innerHTML;
//           inventory.classList.toggle('visibility-hidden', newInventory.innerText === '');
//         }

//         const customLabels = document.querySelectorAll(`[id^="custom-label-${this.dataset.section}"]`);
//         const newCustomLabels = doc.querySelectorAll(`[id^="custom-label-${sectionId}"]`);
//         customLabels.forEach((label, index) => {
//           label.innerHTML = newCustomLabels[index].innerHTML;
//         });

//         if (this.QuantityBreaks) {
//           const newQuantityBreaks = doc.getElementById(`quantity-breaks-${sectionId}`);
//           const currentVariants = this.QuantityBreaks.querySelectorAll('.variant-money-change');
//           const newVariants = newQuantityBreaks.querySelectorAll('.variant-money-change');
//           currentVariants.forEach((variant, index) => {
//             variant.innerHTML = newVariants[index].innerHTML;
//           });
//           if (this.QuantityBreaks.hasVariants) {
//             this.QuantityBreaks.variantSelects.forEach((select) => {
//               select.dataset.selectedId = this.currentVariant.id;
//             });
//             const currentSelects = this.QuantityBreaks.querySelectorAll('.quantity-break__variant-select');
//             const newSelects = newQuantityBreaks.querySelectorAll('.quantity-break__variant-select');
//             currentSelects.forEach((select, index) => {
//               select.innerHTML = newSelects[index].innerHTML;
//             });
//             this.QuantityBreaks.initVariants();
//           }
//         }

//         if (this.secondarySelect) {
//           const newSecondarySelect = doc.getElementById(`${this.secondarySelectSelector}${sectionId}`);
//           if (newSecondarySelect) {
//             this.secondarySelect.innerHTML = newSecondarySelect.innerHTML;
//           }
//         }

//         const submitButton = doc.getElementById(`ProductSubmitButton-${sectionId}`);
//         this.toggleAddButton(
//           submitButton ? submitButton.hasAttribute('disabled') : true,
//           window.variantStrings.soldOut
//         );

//         publish(PUB_SUB_EVENTS.variantChange, {
//           data: {
//             sectionId,
//             html: doc,
//             variant: this.currentVariant,
//           },
//         });
//       });
//   }

//   toggleAddButton(disable = true, text, update = true) {
//     const form = document.getElementById(`product-form-${this.dataset.section}`);
//     if (!form) {
//       return;
//     }
//     const button = form.querySelector('[name="add"]');
//     const buttonText = form.querySelector('[name="add"] > span');
//     if (!button) {
//       return;
//     }

//     if (disable) {
//       button.setAttribute('disabled', 'disabled');
//       if (text) {
//         buttonText.textContent = text;
//       }
//     } else {
//       button.removeAttribute('disabled');
//       buttonText.textContent = text;
//     }

//     if (!update) {
//       return;
//     }
//     button.classList.toggle('hidden', disable);
//     form.querySelector('.payment-buttons').classList.toggle('hidden', disable);
//   }

//   setUnavailable() {
//     const button = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
//     const buttonText = button.querySelector('span');
//     buttonText.textContent = window.variantStrings.unavailable;
//     document.getElementById(`price-${this.dataset.section}`).innerHTML = '';
//   }

//   getVariantData() {
//     this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
//     return this.variantData;
//   }
// }

// customElements.define('variant-selects', VariantSelects);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.secondarySelectSelector = 'StickyAtcVariantPicker-';
    this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = false;
    this.QuantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
    this.addEventListener('change', this.onVariantChange);
  }
  ['onVariantChange']() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  ['updateOptions']() {
    const _0x4acd78 = [];
    this.querySelectorAll('.product-form__input').forEach((_0x10a364) => {
      let _0x3004cc;
      const _0x2c3a17 = _0x10a364.querySelector('.product-form__input__type').dataset.type;
      if (_0x2c3a17 == 'dropdown' || _0x2c3a17 == 'dropdwon') {
        _0x3004cc = _0x10a364.querySelector('select').value;
      } else {
        _0x3004cc = _0x10a364.querySelector('input[type="radio"]:checked').value;
      }
      _0x4acd78.push(_0x3004cc);
    });
    this.options = _0x4acd78;
  }
  ['updateMasterId']() {
    this.currentVariant = this.getVariantData().find((_0x14660d) => {
      return !_0x14660d.options
        .map((_0x2220ab, _0x30d87d) => {
          return this.options[_0x30d87d] === _0x2220ab;
        })
        .includes(false);
    });
  }
  ['updateMedia']() {
    if (!this.currentVariant) {
      return;
    }
    if (!this.currentVariant.featured_media) {
      return;
    }
    const _0x210d10 = document.querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]');
    _0x210d10.forEach((_0x2ea236) =>
      _0x2ea236.setActiveMedia(this.dataset.section + '-' + this.currentVariant.featured_media.id, true)
    );
    const _0x198eb1 = document.querySelector(
      '#ProductModal-' + this.dataset.section + ' .product-media-modal__content'
    );
    if (!_0x198eb1) {
      return;
    }
    const _0x5b4d99 = _0x198eb1.querySelector('[data-media-id="' + this.currentVariant.featured_media.id + '"]');
    _0x198eb1.prepend(_0x5b4d99);
  }
  ['updateURL']() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') {
      return;
    }
    window.history.replaceState({}, '', this.dataset.url + '?variant=' + this.currentVariant.id);
  }
  ['updateShareUrl']() {
    const _0x1ea81b = document.getElementById('Share-' + this.dataset.section);
    if (!_0x1ea81b || !_0x1ea81b.updateUrl) {
      return;
    }
    _0x1ea81b.updateUrl('' + window.shopUrl + this.dataset.url + '?variant=' + this.currentVariant.id);
  }
  ['updateVariantInput']() {
    const _0x575dff = document.querySelectorAll(
      '#product-form-' + this.dataset.section + ', #product-form-installment-' + this.dataset.section
    );
    _0x575dff.forEach((_0x327ca0) => {
      const _0x542a96 = _0x327ca0.querySelector('input[name="id"]');
      _0x542a96.value = this.currentVariant.id;
      _0x542a96.dataset.selectedId = this.currentVariant.id;
      _0x542a96.dispatchEvent(
        new Event('change', {
          bubbles: true,
        })
      );
    });
  }
  ['updateVariantStatuses']() {
    const _0x4acc6e = this.variantData.filter(
      (_0x3a8f2e) => this.querySelector(':checked').value === _0x3a8f2e.option1
    );
    const _0x424572 = [...this.querySelectorAll('.product-form__input')];
    _0x424572.forEach((_0xdc5a30, _0x58cf77) => {
      if (_0x58cf77 === 0x0) {
        return;
      }
      const _0x5dcb59 = [..._0xdc5a30.querySelectorAll('input[type="radio"], option')];
      const _0x35213f = _0x424572[_0x58cf77 - 0x1].querySelector(':checked').value;
      const _0x592c47 = _0x4acc6e
        .filter((_0x2cda8b) => _0x2cda8b.available && _0x2cda8b['option' + _0x58cf77] === _0x35213f)
        .map((_0x30e842) => _0x30e842['option' + (_0x58cf77 + 0x1)]);
      this.setInputAvailability(_0x5dcb59, _0x592c47);
    });
  }
  ['setInputAvailability'](_0x4839f7, _0x5ee5c4) {
    _0x4839f7.forEach((_0x159bde) => {
      if (_0x159bde.nodeName === 'option') {
        if (_0x5ee5c4.includes(_0x159bde.getAttribute('value'))) {
          _0x159bde.innerText = _0x159bde.getAttribute('value');
        } else {
          _0x159bde.innerText = window.variantStrings.unavailable_with_option.replace(
            '[value]',
            _0x159bde.getAttribute('value')
          );
        }
      } else if (_0x5ee5c4.includes(_0x159bde.getAttribute('value'))) {
        _0x159bde.classList.remove('disabled');
      } else {
        _0x159bde.classList.add('disabled');
      }
    });
  }
  ['updatePickupAvailability']() {
    const _0x54592e = document.querySelector('pickup-availability');
    if (!_0x54592e) {
      return;
    }
    if (this.currentVariant && this.currentVariant.available) {
      _0x54592e.fetchAvailability(this.currentVariant.id);
    } else {
      _0x54592e.removeAttribute('available');
      _0x54592e.innerHTML = '';
    }
  }
  ['removeErrorMessage']() {
    const _0x31fe04 = this.closest('section');
    if (!_0x31fe04) {
      return;
    }
    const _0x55b021 = _0x31fe04.querySelector('product-form');
    if (_0x55b021) {
      _0x55b021.handleErrorMessage();
    }
  }
  ['renderProductInfo']() {
    const _0x3db37b = this.currentVariant.id;
    const _0x4ab1dd = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(
      this.dataset.url +
        '?variant=' +
        _0x3db37b +
        '&section_id=' +
        (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
    )
      .then((_0x12c158) => _0x12c158.text())
      .then((_0x3d5899) => {
        if (this.currentVariant.id !== _0x3db37b) {
          return;
        }
        const _0x15cc32 = new DOMParser().parseFromString(_0x3d5899, 'text/html');
        const _0x2259f2 = document.getElementById('price-' + this.dataset.section);
        const _0x5a2183 = _0x15cc32.getElementById(
          'price-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
        );
        const _0x1fa91d = document.getElementById('atc-price-' + this.dataset.section);
        const _0xd525a9 = _0x15cc32.getElementById(
          'atc-price-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
        );
        const _0x90c6ca = _0x15cc32.getElementById(
          'Sku-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
        );
        const _0x14b0fa = document.getElementById('Sku-' + this.dataset.section);
        const _0x3e17b9 = _0x15cc32.getElementById(
          'Inventory-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
        );
        const _0x5b6a2c = document.getElementById('Inventory-' + this.dataset.section);
        if (_0x5a2183 && _0x2259f2) {
          _0x2259f2.innerHTML = _0x5a2183.innerHTML;
        }
        if (_0xd525a9 && _0x1fa91d) {
          _0x1fa91d.innerHTML = _0xd525a9.innerHTML;
        }
        const _0x35d113 = document.querySelectorAll('[id^="custom-label-' + this.dataset.section + '"]');
        const _0x1fa2df = _0x15cc32.querySelectorAll(
          '[id^="custom-label-' +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) +
            '"]'
        );
        if (_0x35d113 && _0x1fa2df) {
          for (var _0x432647 = 0x0; _0x432647 < _0x35d113.length; _0x432647++) {
            _0x35d113[_0x432647].innerHTML = _0x1fa2df[_0x432647].innerHTML;
          }
        }
        if (this.QuantityBreaks) {
          const _0x1f398f = _0x15cc32.getElementById(
            'quantity-breaks-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
          );
          const _0x43a275 = this.QuantityBreaks.querySelectorAll('.variant-money-change');
          const _0x185214 = _0x1f398f.querySelectorAll('.variant-money-change');
          for (let _0x3cb3c7 = 0x0; _0x3cb3c7 < _0x43a275.length; _0x3cb3c7++) {
            _0x43a275[_0x3cb3c7].innerHTML = _0x185214[_0x3cb3c7].innerHTML;
          }
          if (this.QuantityBreaks.hasVariants) {
            const _0x2d565c = _0x15cc32.getElementById(
              'quantity-breaks-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
            );
            this.QuantityBreaks.variantSelects.forEach((_0x14aa8a) => {
              _0x14aa8a.dataset.selectedId = this.currentVariant.id;
            });
            const _0x41e6de = this.QuantityBreaks.querySelectorAll('.quantity-break__variant-select');
            const _0x1728fe = _0x2d565c.querySelectorAll('.quantity-break__variant-select');
            for (let _0x83dd0 = 0x0; _0x83dd0 < _0x41e6de.length; _0x83dd0++) {
              _0x41e6de[_0x83dd0].innerHTML = _0x1728fe[_0x83dd0].innerHTML;
            }
            this.QuantityBreaks.initVariants();
          }
        }
        if (_0x3e17b9 && _0x5b6a2c) {
          _0x5b6a2c.innerHTML = _0x3e17b9.innerHTML;
        }
        if (_0x90c6ca && _0x14b0fa) {
          _0x14b0fa.innerHTML = _0x90c6ca.innerHTML;
          _0x14b0fa.classList.toggle('visibility-hidden', _0x90c6ca.classList.contains('visibility-hidden'));
        }
        const _0x35a11f = document.getElementById('price-' + this.dataset.section);
        if (_0x35a11f) {
          _0x35a11f.classList.remove('visibility-hidden');
        }
        if (_0x5b6a2c) {
          _0x5b6a2c.classList.toggle('visibility-hidden', _0x3e17b9.innerText === '');
        }
        if (this.secondarySelect) {
          const _0x1488b9 = _0x15cc32.getElementById(
            '' +
              this.secondarySelectSelector +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
          );
          if (_0x1488b9) {
            this.secondarySelect.innerHTML = _0x1488b9.innerHTML;
          }
        }
        const _0x38ce5d = _0x15cc32.getElementById('ProductSubmitButton-' + _0x4ab1dd);
        this.toggleAddButton(_0x38ce5d ? _0x38ce5d.hasAttribute('disabled') : true, window.variantStrings.soldOut);
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: _0x4ab1dd,
            html: _0x15cc32,
            variant: this.currentVariant,
          },
        });
      });
  }
  ['toggleAddButton'](_0x47cf11 = true, _0x99cee5, _0x48e7e8 = true) {
    const _0x5ec638 = document.getElementById('product-form-' + this.dataset.section);
    if (!_0x5ec638) {
      return;
    }
    const _0xb14073 = _0x5ec638.querySelector('[name="add"]');
    const _0x55911a = _0x5ec638.querySelector('[name="add"] > span');
    if (!_0xb14073) {
      return;
    }
    if (_0x47cf11) {
      _0xb14073.setAttribute('disabled', 'disabled');
      if (_0x99cee5) {
        _0x55911a.textContent = _0x99cee5;
      }
    } else {
      _0xb14073.removeAttribute('disabled');
      _0x55911a.textContent = window.variantStrings.addToCart;
    }
    if (!_0x48e7e8) {
      return;
    }
  }
  ['setUnavailable']() {
    const _0x5897e1 = document.getElementById('product-form-' + this.dataset.section);
    const _0x5d137f = _0x5897e1.querySelector('[name="add"]');
    const _0x4a430e = _0x5897e1.querySelector('[name="add"] > span');
    const _0x5eca97 = document.getElementById('price-' + this.dataset.section);
    const _0x2cb0af = document.getElementById('Inventory-' + this.dataset.section);
    const _0x415c91 = document.getElementById('Sku-' + this.dataset.section);
    if (!_0x5d137f) {
      return;
    }
    _0x4a430e.textContent = window.variantStrings.unavailable;
    if (_0x5eca97) {
      _0x5eca97.classList.add('visibility-hidden');
    }
    if (_0x2cb0af) {
      _0x2cb0af.classList.add('visibility-hidden');
    }
    if (_0x415c91) {
      _0x415c91.classList.add('visibility-hidden');
    }
  }
  ['getVariantData']() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = 'variant-selects-';
    this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
  ['updateOptions']() {
    this.options = this.querySelector('select').value.split(',');
  }
}
customElements.define('secondary-variant-select', SecondaryVariantSelect);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const loadRecommendations = (entries, observer) => {
      if (!entries[0].isIntersecting) {
        return;
      }
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((html) => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const recommendations = tempDiv.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }
          if (tempDiv.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };

    new IntersectionObserver(loadRecommendations.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
